<template>
    <div class="container">
        <h2 class="mb-10 text-center text-24 xl:text-44 text-primary font-bold">{{ title }}</h2>
        <div class="flex justify-center -m-[.625rem] mb-20">
            <div class="p-[.625rem] cursor-pointer group" v-for="(division, index) in divisions" @click="toggleDivision(division)" :key="index">
                <span
                    class="py-[.625rem] text-18 px-[1.25rem] select-none group-hover:bg-opacity-100 group-hover:text-white transition-all rounded-lg bg-green bg-opacity-10 text-green"
                    :class="{ 'bg-opacity-100 !text-white': division == filter.division }"
                    v-html="division.name"
                ></span>
            </div>
        </div>
        <div class="flex flex-wrap -m-5 lg:-m-10 2xl:-m-5" ref="peoples">
            <div v-for="(person, index) in filteredmembers" :key="index" class="w-full mb-10 md:w-1/2 lg:w-4/12 xl:w-1/4 2xl:w-1/5 p-5 lg:p-8 2xl:p-5">
                <div class="block relative" data-aos="fade-up">
                    <div class="group aspect-[240/280] block relative">
                        <img class="mb-5 absolute inset-0 w-full object-center object-cover h-full lazyload" v-if="person.image" :data-src="person.image.sizes.medium_large" />
                        <div
                            class="absolute inset-0 w-full select-none text-white p-5 text-24 font-bold text-center h-full flex justify-center z-20 opacity-0 group-hover:opacity-100 transition-opacity items-center bg-opacity-50"
                            :class="person.background_color"
                            v-if="person.quote && person.quote !== ''"
                        >
                            “{{ person.quote }}“
                        </div>
                        <svg class="w-full h-auto absolute bottom-0 z-30" viewBox="0 0 240 115" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M0 115V0C58.6323 64.2253 184.43 88.4272 240 95V115H0Z" fill="currentColor" :class="person.background_color.replace('bg', 'text')" />
                            <path d="M0 115V15C58.6323 79.2253 184.43 108.427 240 115H0Z" fill="white" />
                        </svg>
                    </div>
                    <div class="p-5">
                        <div class="relative">
                            <a target="_blank" :href="person.linkedin_url" v-if="person.linkedin_url && person.linkedin_url !== ''" class="absolute left-0 bottom-[calc(100%+20px)] bg-white z-50">
                                <div class="bg-[#056a8f] rounded-sm p-[1px]">
                                    <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                        <circle cx="4.983" cy="5.009" r="2.188" fill="#fff" />
                                        <path
                                            d="M9.237 8.855v12.139h3.769v-6.003c0-1.584.298-3.118 2.262-3.118c1.937 0 1.961 1.811 1.961 3.218v5.904H21v-6.657c0-3.27-.704-5.783-4.526-5.783c-1.835 0-3.065 1.007-3.568 1.96h-.051v-1.66H9.237zm-6.142 0H6.87v12.139H3.095z"
                                            fill="#fff"
                                        />
                                    </svg>
                                </div>
                            </a>
                            <span class="font-bold text-primary block text-24 mb-[.625rem]">{{ person.name }} </span>
                            <span class="text-primary text-18 2xl:text-[16px] block" :class="person.background_color.replace('bg', 'text')">{{ person.titel }}</span>
                            <span class="text-18 2xl:text-[16px] text-primary" v-html="person.field.name"></span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
var scrollIntoView = require('scroll-into-view');

export default {
    props: {
        people: {
            type: Array,
            required: true,
        },
        title: {
            type: String,
            required: true,
        },
    },

    data() {
        return {
            filter: {
                division: null,
            },
            divisions: null,
        };
    },

    mounted() {
        this.getDivisions();
    },

    methods: {
        toggleDivision(division) {
            if (this.filter.division == division) {
                this.filter.division = null;
            } else {
                this.filter.division = division;
            }

            scrollIntoView(this.$refs.peoples);
        },

        getDivisions() {
            const self = this;
            return new Promise(function (resolve, reject) {
                axios
                    .get('/api/job-fields')
                    .then(function (response) {
                        self.divisions = response.data;
                        resolve(response.data);
                    })
                    .catch(function (error) {
                        reject(error);
                    });
            });
        },
    },

    computed: {
        filteredmembers() {
            let filteredmembers = this.people;

            if (this.filter.division != null) {
                filteredmembers = filteredmembers.filter((member) => member.field.term_id === this.filter.division.id);
            }

            return filteredmembers;
        },
    },
};
</script>
